namespace HA.Core.Route {
    export class HARouter extends HAObject {

        public doGet(data: Map<string, any>): Promise<Map<string, any>> {
            const request = this.createRequest();
            return request.doGet(data.get("url"), data.get("cb"));
        }

        public post(data: Map<string, any>): Promise<Map<string, any>> {
            const request = this.createRequest();
            return request.post(data.get("url"), data.get("data"), data.get("cb"));
        }

        /**
         *
         * @returns {HA.HTTPRequest}
         */
        protected createRequest() {
            const request = new HTTPRequest();
            this.getRequests().push(request);

            return request;
        }

        /**
         *
         * @returns {Array<HTTPRequest>}
         */
        protected getRequests() {
            return this.get("requests");
        }

        protected initialize(data?: Map<any, any>) {
            super.initialize(data);
            this.addToData("requests", []);
        }
    }

    export class HTTPRequest extends HAObject {

        /**
         *
         * @param request
         * @returns {HA.HTTPResponse}
         */
        public static createResponse(request: XMLHttpRequest) {
            return new HTTPResponse(request);
        }

        public doGet(url: string, cbFunction?: any): Promise<any> {

            return new Promise((resolve, reject) => {
                const request = this.getRequest();
                request.open("GET", url);
                request.send();
                const me = this;
                request.onreadystatechange = () => {
                    if (request.readyState === 4) {
                        resolve(HTTPRequest.createResponse(me.getRequest()).toMap());
                    }
                };
            });
        }

        public post(url: string, data?: any, cbFunction?: any): Promise<any> {
            if (data instanceof Map) {
                data.set("ts", Date.now());
                data.set("_sh", screen.height);
                data.set("_sw", screen.width);
                data = toObj(data);
            } else {
                data.ts = Date.now();

                data._sh = screen.height;
                data._sw = screen.width;
            }

            return new Promise((resolve, reject) => {
                const request = this.getRequest();
                request.open("POST", url);

                if (data instanceof FormData) {
                    request.send(data);
                } else {
                    request.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=UTF-8");
                    const urlParameters = Object.keys(data).map((k) => {
                        return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
                    }).join("&");
                    request.send(urlParameters);
                }

                const me = this;
                request.onreadystatechange = () => {
                    if (request.readyState === 4) {
                        resolve(HTTPRequest.createResponse(me.getRequest()).toMap());
                    }
                };
            });

        }

        protected ready(): Promise<any>|any {

            if (this.get("cbFunction")) {
                return this.get("cbFunction")(HTTPRequest.createResponse(this.getRequest()));
            }
            return new Promise((resolve) => resolve(HTTPRequest.createResponse(this.getRequest())));
        }

        /**
         *
         * @returns {(ev:ProgressEvent)=>any}
         */
        protected watch() {
            const me = this;
            this.getRequest().onreadystatechange = () => {
                if (me.getRequest().readyState === 4) {
                    return me.ready();
                }
            };

            return this.getRequest().onreadystatechange;
        }

        /**
         *
         * @param data
         */
        protected initialize(data?: Map<any, any>) {
            super.initialize(data);
            const request = new XMLHttpRequest();
            this.addToData("request", request);
        }

        protected getRequest(): XMLHttpRequest {
            return this.get("request");
        }
    }

    export class HTTPResponse extends HAObject {

        /**
         *
         * @returns {any}
         */
        public getJSON() {
            return JSON.parse(this.getRequest().responseText);
        }

        /**
         *
         * @returns {Map}
         */
        public toMap() {
            return toMap(this.getJSON());
        }

        /**
         *
         * @param request
         */
        protected initialize(request: XMLHttpRequest) {
            const data = toMap({request});
            super.initialize(data);
        }

        /**
         *
         * @returns {XMLHttpRequest}
         */
        protected getRequest() {
            return this.get("request");
        }
    }

    export let Router: HARouter = new HARouter();
}
